if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.productCard = this.closest('.product-card');
        this.productUrl = this.productCard.querySelector('a[id^="CardLink"]')?.href;
        this.preloadData = null;

        const cardLink = this.productCard.querySelector('a[id^="CardLink"]');
        const stickerText = cardLink?.querySelector('.sticker-text');
        this.productTitle = stickerText?.textContent || cardLink?.textContent;

        //this.isPreloading = false;

        // if (window.matchMedia('(hover: hover)').matches) {
        //   this.productCard.addEventListener('mouseover', () => {
        //     if (!this.preloadData && !this.isPreloading) {
        //       this.isPreloading = true;
        //       this.fetchProductData().then(data => {
        //         this.preloadData = data;
        //         this.isPreloading = false;
        //       });
        //     }
        //   });
        // }
      }

      async fetchProductData() {
        // EN_QV_FAST_SECTION_20261022: load only the current theme's product section
        // instead of 1.2 MB of complete page. Fall back safely for alternate templates.
        const preferredSection = 'template--18920297169061__main';
        const sectionUrl = new URL(this.productUrl, window.location.origin);
        sectionUrl.searchParams.set('section_id', preferredSection);
        let product = null;
        try {
          const response = await fetch(sectionUrl.toString());
          if (response.ok) {
            const html = await response.text();
            const documentSection = new DOMParser().parseFromString(html, 'text/html');
            const candidate = documentSection.querySelector('div[id^="MainProduct-"]');
            if (candidate && candidate.dataset.section === preferredSection &&
                candidate.querySelector('.product') && candidate.querySelector('product-info')) {
              product = candidate;
              this.dataset.enQuickFetch = 'section';
            }
          }
        } catch (error) {
          // An unavailable section must not stop the Quick View experience.
        }
        if (!product) {
          const response = await fetch(this.productUrl);
          if (!response.ok) throw new Error('Quick View unavailable');
          const html = await response.text();
          product = new DOMParser().parseFromString(html, 'text/html').querySelector('div[id^="MainProduct-"]');
          this.dataset.enQuickFetch = 'full';
        }
        if (!product) throw new Error('Quick View unavailable');
        this.productElement = product;
        this.productElement.classList.forEach(classApplied => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient') {
            this.modalContent.classList.add(classApplied);
          }
        });
        this.preventDuplicatedIDs();
        this.removeDOMElements();
        return this.productElement.innerHTML;
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) {
          cartNotification.init();
          cartNotification.setActiveElement(this.openedBy);
        }

        this.quickSpecResizeObserver?.disconnect();
        this.quickSpecResizeObserver = null;
        this.quickSpecCleanup?.();
        this.quickSpecCleanup = null;
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        publish(PUB_SUB_EVENTS.quickViewClose);
        super.hide();
      }

      show(opener) {
        if (this.hasAttribute('data-gds-collection')) {
          if (opener.classList.contains('loading')) return;
          this.productCard.querySelector('.gds-quick-view-error')?.remove();
        }
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden', 'spinning-complete');

        const finalizeShow = (productHTML) => {
          this.setInnerHTML(this.modalContent, productHTML);
          // EN_QV_SKIP_PLACEHOLDER_SPEC_20261022
          this.hideQuickViewPlaceholderSpecs();

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          this.prependProductTitle();
          window.renderSelects();
          window.loadDesktopOnlyTemplates();
          super.show(opener);
          // EN_QUICK_SPEC_ADAPTIVE_20261020: initialize the same row-width logic after modal is visible.
          requestAnimationFrame(() => this.initQuickSpecification());
          // PayPal provides one active frame plus an invisible prerender frame; keep both.
          // Remove only additional ACTIVE visible wallet buttons if Shopify injects duplicates.
          [350, 1300, 2800].forEach(delay => setTimeout(() => {
            if (this.hasAttribute('open')) this.dedupeQuickViewPayPal();
          }, delay));

          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading__spinner').classList.add('hidden', 'spinning-complete');

          publish(PUB_SUB_EVENTS.quickViewOpen);
          publish('quick-buy-action-complete');

          setTimeout(() => {
            if (window.ProductModel) window.ProductModel.loadShopifyXR();
          }, 500);
        };

        if (this.preloadData) {
          finalizeShow(this.preloadData);
        } else {
          this.productUrl = opener.getAttribute('data-product-url');
          const request = this.fetchProductData().then(finalizeShow);
          if (this.hasAttribute('data-gds-collection')) {
            request.catch(() => {
              opener.removeAttribute('aria-disabled');
              opener.classList.remove('loading');
              opener.querySelector('.loading__spinner').classList.add('hidden', 'spinning-complete');
              const message = document.createElement('p');
              message.className = 'gds-quick-view-error';
              message.setAttribute('role', 'alert');
              message.append(document.createTextNode(this.dataset.loadError + '. '));
              const link = document.createElement('a');
              link.href = this.productUrl;
              link.textContent = window.strings.product.readMore;
              message.append(link);
              opener.closest('modal-opener').after(message);
            });
          }
        }
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Re-injects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        // Remove elements from QB that shouldn't be there
        element.querySelectorAll('.quick-add-hidden').forEach((elem) => {
          elem.remove();
        });
      }

      dedupeQuickViewPayPal() {
        const payment = this.modalContent.querySelector('.shopify-payment-button');
        if (!payment) return;
        const wallets = [...payment.querySelectorAll('shopify-paypal-button')];
        wallets.slice(1).forEach(node => node.remove());
        const checkouts = [...payment.querySelectorAll('shopify-accelerated-checkout')];
        checkouts.slice(1).forEach(node => node.remove());
        const active = [...payment.querySelectorAll('iframe.component-frame.visible[title*="PayPal"]')];
        const firstWrapper = active[0]?.closest('.paypal-buttons');
        for (const frame of active.slice(1)) {
          const wrapper = frame.closest('.paypal-buttons');
          if (wrapper && wrapper !== firstWrapper) wrapper.style.display = 'none';
          else frame.style.display = 'none';
        }
      }

      hideQuickViewPlaceholderSpecs() {
        // The full Product Page suppresses fallback/empty Shopify example tables.
        // Quick View must do the same, without affecting genuine Specification data.
        const info = this.modalContent.querySelector('product-info');
        const state = info?.dataset.enSpecAuto;
        const hideStates = ['pending', 'fallback', 'empty'];
        for (const panel of this.modalContent.querySelectorAll('.product__info-panel')) {
          const table = panel.querySelector('table.theme-table:not(.en-spec-auto-table)');
          if (!table) continue;
          const rows = [...table.querySelectorAll('tr')];
          const sample = rows.length > 0 && rows.every(row => {
            const cells = [...row.children].map(cell => (cell.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase());
            return cells.length === 2 && cells[0] === 'example label' && cells[1] === 'value';
          });
          if (sample || hideStates.includes(state)) {
            panel.classList.add('en-qv-placeholder-spec-hidden');
          }
        }
      }

      initQuickSpecification() {
        // Mirror Product Page's label/value-measured divider. Never change metafield data.
        const table = this.modalContent.querySelector('.en-spec-auto-panel .en-spec-auto-table');
        if (!table || table.dataset.enSpecAdaptive === 'ready') return;
        const rows = [...table.querySelectorAll('tbody > tr')];
        if (!rows.length || rows.some(row => row.children.length !== 2)) return;
        table.dataset.enSpecAdaptive = 'ready';
        // EN_QV_FAST_CANVAS_MEASURE_20261022: measure text without forcing
        // a separate page layout for each Specification table cell.
        const context = document.createElement('canvas').getContext('2d');
        let lastWidth = 0;
        const needed = cell => {
          const style = getComputedStyle(cell);
          context.font = style.font;
          const text = (cell.textContent || '').replace(/\s+/g, ' ').trim();
          const letterSpacing = parseFloat(style.letterSpacing) || 0;
          return context.measureText(text).width +
            Math.max(0, text.length - 1) * letterSpacing +
            (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0) +
            (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.borderRightWidth) || 0) + 3;
        };
        const update = () => {
          if (!table.isConnected) return;
          const available = table.clientWidth - 2;
          if (available < 120) return;
          lastWidth = available;
          const standard = available * 0.42;
          const sizes = rows.map(row => [needed(row.children[0]), needed(row.children[1])]);
          const label = Math.max(...sizes.map(pair => pair[0]));
          const value = Math.max(...sizes.map(pair => pair[1]));
          let chosen = standard;
          if (label + value <= available) chosen = Math.max(label, Math.min(standard, available - value));
          else if (label > standard) chosen = label;
          else if (value > available - standard) chosen = available - value;
          chosen = Math.max(available * 0.30, Math.min(available * 0.70, chosen));
          if (Math.abs(chosen - standard) > 2) table.style.setProperty('--en-spec-left', chosen.toFixed(1) + 'px');
          else table.style.removeProperty('--en-spec-left');
        };
        update();
        document.fonts?.ready.then(update);
        if ('ResizeObserver' in window) {
          this.quickSpecResizeObserver?.disconnect();
          this.quickSpecResizeObserver = new ResizeObserver(() => {
            if (Math.abs((table.clientWidth - 2) - lastWidth) > 1) update();
          });
          this.quickSpecResizeObserver.observe(table);
        }
        window.addEventListener('resize', update, {passive:true});
        this.quickSpecCleanup = () => {
          window.removeEventListener('resize', update);
          // Canvas requires no DOM cleanup.
        };
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      prependProductTitle() {
        const product = this.modalContent.querySelector('.product');
        if (!product.querySelector('.product__title')) {
          const container = product.querySelector('product-info .product__info-container');
          const productTitleHTML = `
              <div class="product__title">
                <a href="${this.productUrl}" class="link un-underlined-link">
                  <h2 class="h2 mt-0">
                    ${this.productTitle}
                    <span class="product__read-more block underlined-link t4">${window.strings.product.readMore}</span>
                  </h2>
                </a>
              </div>`;
          container.innerHTML = productTitleHTML + container.innerHTML;
        }
      }
    }
  );
}
